import { render, staticRenderFns } from "./Grafico1.vue?vue&type=template&id=324b81b0"
import script from "./Grafico1.vue?vue&type=script&lang=js"
export * from "./Grafico1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports